import { render, staticRenderFns } from "./PdfIcon.vue?vue&type=template&id=a53863ca&scoped=true&"
import script from "./PdfIcon.vue?vue&type=script&lang=ts&"
export * from "./PdfIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PdfIcon.vue?vue&type=style&index=0&id=a53863ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53863ca",
  null
  
)

export default component.exports